module.exports = __webpack_public_path__ + "img/figuur.b.7f5ee09d.svg";